import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OwnedContactsVendorType } from '../../../../../shared/dto';

@Component({
    selector: 'app-crm-warning-dialog',
    template: `
		<app-si-dialog #dialogComponent header="Only one CRM can be enabled for sync" saveButtonText="Turn off" (save)="dialogComponent.onClose(true)">
			<ng-template appDialogBody>
				<div class="py-12">
					<div class="flex flex-wrap -mx-2 gap-0">
						<div class="flex-none w-2/3 ml-[16.666667%] px-2">
							<p class="mb-0">
								{{ titles[data.toDisable] }} search filters must be disabled before turning on {{ titles[data.toEnable] }} search filters.
							</p>
						</div>
					</div>
				</div>
			</ng-template>
		</app-si-dialog>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CrmWarningDialogComponent {
    readonly titles: Record<OwnedContactsVendorType, string> = {
        SALESFORCE: 'Salesforce',
        HUBSPOT: 'HubSpot',
    };

    constructor(@Inject(MAT_DIALOG_DATA) public readonly data: {
        toDisable: OwnedContactsVendorType,
        toEnable: OwnedContactsVendorType,
    }) {
    }
}
